import * as R from 'ramda'
import * as recompose from 'recompose'
import { connect } from 'react-redux'

import { withTranslate } from '@rushplay/i18n'

import { PromoText as Component } from './promo-text'

function mapStateToProps(state, props) {
  const textKey = `${props.section}.promo.top.text`
  const linkKey = `${props.section}.promo.top.link`

  const textTranslationKeyExists = props.isExistingTranslation(textKey)
  const linkTranslationKeyExists = props.isExistingTranslation(linkKey)

  const isVisible = textTranslationKeyExists && linkTranslationKeyExists

  return {
    visible: isVisible,
    text: isVisible && textKey,
    link: isVisible && linkKey,
  }
}

export const PromoText = R.compose(
  withTranslate,
  connect(mapStateToProps),
  recompose.branch(props => R.not(props.visible), recompose.renderNothing)
)(Component)
